import React, {FC} from "react";
import styles from "./SkeletonSourceItem.module.scss";

export const SkeletonSourceItem: FC = () => {

  return <div className={styles.switchCustomSourceContainer}>
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.skeletonTitle}/>
        <div className={styles.toggle}>
          <div className={styles.toggleThumb}>
            <span className={styles.thumbLayerHidden}/>
            <span className={styles.thumbLayerVisible}/>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.skeletonCircle}/>
  </div>
}
